import React, { useState, useEffect } from 'react';
import './receipt.css';
import { jsPDF } from 'jspdf';
import logoImage from '../../assets/e-techno copy.png';

const PaymentReceipt = ({ 
  paymentId, 
  name, 
  phone, 
  panAadhaar, 
  amount, 
  email, 
  address, 
  message 
}) => {
  const [receiptData, setReceiptData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchReceipt = async () => {
      try {
        const response = await fetch(`https://razorpay-etechno.azurewebsites.net/api/payment/receipt/${paymentId}`, {
          method: 'GET',
          headers: { 
            'Content-Type': 'application/json',
            'x-functions-key': 'B5a7RJ8Gp0cpzGwZfv_Bo2Okdr_tOFvLclsXjWtPC-X0AzFus9t24w==',
            
          }
        });

        if (!response.ok) {
          throw new Error('Failed to fetch receipt');
        }

        const data = await response.json();
        console.log('Receipt data:', data);
        setReceiptData(data.paymentDetails);
      } catch (err) {
        setError(err.message);
        console.error('Receipt fetch error:', err);
      }
    };

    if (paymentId) {
      fetchReceipt();
    }
  }, [paymentId]);

  const formatAmount = (value) => {
    return parseFloat(value).toFixed(2);
  };

  const formatCurrency = (value) => {
    return `Rs. ${formatAmount(value)}`;
  };

  const downloadReceipt = () => {
    if (!receiptData) return;

    const doc = new jsPDF({
      filters: ["ASCIIHexEncode"]
    });
    
    const pageWidth = doc.internal.pageSize.width;
    
    // Add company header
    doc.setFontSize(16);
    doc.text('E-Techno Educational and Research Society', 20, 20);
    doc.setFontSize(10);
    doc.text('Website: www.etechno.org', 20, 30);
    doc.text('Address: 460 Paschim Vihar - 110063', 20, 35);
    doc.text('PAN: AACAE7007Q', 20,40);
    doc.text('Registration Number: AACAE7007QF20241', 20, 45);
    doc.text('Email: contact@etechno.org', 20, 50);
    doc.text('Phone: +91 9811133790', 20, 55);

    // Add logo
    doc.addImage(logoImage, 'PNG', 150, 15, 30, 30);

    // Add "RECEIPT" text
    doc.setFontSize(20);
    doc.setFont('helvetica', 'bold');
    doc.text('RECEIPT', 150, 70);

    // Add receipt details (right-aligned)
    doc.setFontSize(10);
    const receiptNoText = `Receipt No: #${receiptData.id}`;
    const dateText = `Payment Date: ${new Date(receiptData.date).toLocaleDateString()}`;
    doc.text(receiptNoText, pageWidth - 20, 80, { align: 'right' });
    doc.text(dateText, pageWidth - 20, 85, { align: 'right' });

    // Add Bill To section
    doc.setFont('helvetica', 'bold');
    doc.text('BILL TO', 20, 70);
    doc.setFont('helvetica', 'normal');
    doc.text(name, 20, 80);
    doc.text(address, 20, 85);
    doc.text(panAadhaar, 20, 90);
    doc.text(phone, 20, 95);
    doc.text(email, 20, 100);

    // Define table column positions
    const columns = {
      description: 20,
      qty: 100,
      unitPrice: 140,
      total: 180
    };

    // Add table headers
    doc.setFont('helvetica', 'bold');
    const tableTop = 110;
    doc.line(20, tableTop, 190, tableTop);
    
    // Headers
    doc.text('DESCRIPTION', columns.description, tableTop + 10);
    doc.text('QTY', columns.qty, tableTop + 10);
    doc.text('UNIT PRICE', columns.unitPrice, tableTop + 10);
    doc.text('TOTAL', columns.total, tableTop + 10);
    doc.line(20, tableTop + 15, 190, tableTop + 15);

    // Table content with aligned columns
    doc.setFont('helvetica', 'normal');
    doc.text('Donation', columns.description, tableTop + 25);
    doc.text('1', columns.qty, tableTop + 25);
    doc.text(formatCurrency(amount), columns.unitPrice, tableTop + 25);
    doc.text(formatCurrency(amount), columns.total, tableTop + 25);
    doc.line(20, tableTop + 90, 190, tableTop + 90);

    // Adjust totals alignment
    const labelsX = 140;  // Aligned with UNIT PRICE column
    const rightColumnX = 180;  // Aligned with TOTAL column
    
    doc.text('SUBTOTAL', labelsX, tableTop + 100);
    doc.text(formatCurrency(amount), rightColumnX, tableTop + 100);
    
    // doc.text('DISCOUNT', labelsX, tableTop + 110);
    // doc.text('Rs. 0.00', rightColumnX, tableTop + 110);
    
    
    doc.text('TOTAL', labelsX, tableTop + 110);
    doc.text(formatCurrency(amount), rightColumnX, tableTop + 110);

    // Add notes
    doc.setFont('helvetica', 'bold');
    doc.text('Notes', 20, tableTop + 140);
    doc.setFont('helvetica', 'normal');
    doc.text(`Payment Method: ${receiptData.method}`, 20, tableTop + 150);
    if (message) {
      doc.text(`Message: ${message}`, 20, tableTop + 160);
    }

    // Add footer
    doc.text('Thank you for your generous support!', 105, 280, { align: 'center' });

    doc.save(`Receipt_${paymentId}.pdf`);
  };

  if (error) {
    return (
      <div className="receipt-error">
        Error fetching receipt: {error}
      </div>
    );
  }

  if (!receiptData) {
    return (
      <div className="receipt-loading">
        Loading receipt for {paymentId}...
      </div>
    );
  }

  return (
    <div className="receipt-container">
      <div className="receipt-header">
        <h1 style={{ fontWeight: 'bold' }}>Donation Receipt</h1>
        <p>E-Techno Educational and Research Society</p>
      </div>

      <div className="receipt-donor-info">
        <h2 style={{ fontWeight: 'bold' }}>Donor Information</h2>
        <div className="receipt-details-item">
          <span>Name:</span>
          <strong>{name}</strong>
        </div>
        <div className="receipt-details-item">
          <span>Email:</span>
          <strong>{email}</strong>
        </div>
        <div className="receipt-details-item">
          <span>Phone:</span>
          <strong>{phone}</strong>
        </div>
        <div className="receipt-details-item">
          <span>PAN/Aadhaar:</span>
          <strong>{panAadhaar}</strong>
        </div>
        <div className="receipt-details-item">
          <span>Address:</span>
          <strong>{address}</strong>
        </div>
      </div>

      <div className="receipt-payment-details">
        <h2 style={{ fontWeight: 'bold' }}>Payment Details</h2>
        <div className="receipt-details-item">
          <span>Payment ID:</span>
          <strong>{receiptData.id}</strong>
        </div>
        
        <div className="receipt-details-item">
          <span>Amount:</span>
          <strong>Rs. {formatAmount(amount)}</strong>
        </div>
        
        <div className="receipt-details-item">
          <span>Currency:</span>
          <strong>{receiptData.currency}</strong>
        </div>
        
        <div className="receipt-details-item">
          <span>Payment Method:</span>
          <strong>{receiptData.method}</strong>
        </div>
        
        <div className="receipt-details-item">
          <span>Status:</span>
          <strong>{receiptData.status}</strong>
        </div>
        
        <div className="receipt-details-item">
          <span>Date:</span>
          <strong>{new Date(receiptData.date).toLocaleString()}</strong>
        </div>
      </div>

      {message && (
        <div className="receipt-message">
          <h2 style={{ fontWeight: 'bold' }}>Donor Message</h2>
          <p>{message}</p>
        </div>
      )}

      <div className="receipt-footer">
        <p>Thank you for your generous support!</p>
      </div>

      <button 
        onClick={downloadReceipt} 
        className="receipt-form-submit-button"
      >
        Download Receipt as PDF
      </button>
    </div>
  );
};

export default PaymentReceipt;